import { CacheService } from '../../services/CacheService';
import { Notification, NotificationType } from './Notification';

type CachedNotification = {
  flashType: string;
  type: NotificationType;
  message: string;
};

type NotificationOptions = {
  defer?: boolean;
};

const NOTIFICATION_CACHE_KEY = 'flashes';

export const NOTIFICATION_EVENT_KEY = 'UI_NOTIFICATION';

export class NotificationManager {
  static publish(notifications: Notification[], options?: NotificationOptions) {
    if (options?.defer) {
      this.storeNotifications(notifications);
    } else {
      const event = new CustomEvent<Notification[]>(NOTIFICATION_EVENT_KEY, { detail: notifications });
      window.document.dispatchEvent(event);
    }
  }

  static subscribe(cb: (event: CustomEvent<Notification[]>) => void) {
    window.document.addEventListener(NOTIFICATION_EVENT_KEY, cb);

    // Flush the cache after the event listener has been registered
    const cached = this.readNotifications();
    if (cached.length > 0) {
      this.publish(cached.map((c) => new Notification(c.type, c.message)));
      this.storeNotifications([]);
    }
  }

  static unsubscribe(cb: (event: CustomEvent<Notification[]>) => void) {
    window.document.removeEventListener(NOTIFICATION_EVENT_KEY, cb);
  }

  private static readNotifications(): CachedNotification[] {
    return CacheService.getInstance().getItem<CachedNotification[]>(NOTIFICATION_CACHE_KEY, []) ?? [];
  }

  private static storeNotifications(notifications: Notification[]) {
    CacheService.getInstance().setItem<CachedNotification[]>(
      NOTIFICATION_CACHE_KEY,
      notifications.map((n) => ({
        flashType: 'notification',
        type: n.getType(),
        message: n.getMessage(),
      }))
    );
  }
}
